import React, { Fragment } from 'react'
import { Form } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import useLogin from '../../Hooks/Auth/useLogin'
import AppButton from '../Main/Button'
import { AppInput, PasswordInput } from '../Main/Inputs'


const LoginPage = () => {

    const [
        email,
        password,
        isLoading,
        handleEmailChange,
        handlePasswordChange,
        handleLogin
    ] = useLogin();


    return (
        <Fragment>
            <div className="auth-background" style={{ height: "100vh" }}>
                <div className="overlay h-100" >
                    <div className="container">
                        <div className="row ">
                            <div className="col-lg-5 mt-5">
                                <div className="mt-5 card bg-white border-0 p-5">
                                    <h5 className='heading'>
                                        Sign In
                                    </h5>

                                    <p>
                                        Don’t have an account? <Link className='text-danger' to={"/sign-up"}>Sign Up</Link>
                                    </p>

                                    <Form onSubmit={handleLogin} className='row'>

                                        <div className="col-12 px-0">
                                            <AppInput
                                                type="text"
                                                placeholder="Email"
                                                icon={"email"}
                                                handleChange={handleEmailChange}
                                                value={email}
                                            />
                                        </div>

                                        <div className="col-12 px-0">
                                            <PasswordInput
                                                placeholder="Password"
                                                handleChange={handlePasswordChange}
                                                value={password}
                                            />
                                        </div>


                                        <div className="col p-0">
                                            <Form.Group className="mb-3" controlId="formBasicCheckbox">
                                                <Form.Check type="checkbox" label="Remember Me" />
                                            </Form.Group>
                                        </div>
                                        <div className="col-auto p-0">
                                            <p className='mb-0 '>
                                                <Link className='text-muted' to={"/forgot-password"}>
                                                    Forgot Password?
                                                </Link>
                                            </p>
                                        </div>
                                        <div className='p-0'>
                                            <AppButton
                                                type='submit'
                                                isLoading={isLoading}
                                                className={"w-100"}
                                                title={"Sign In"}
                                            />
                                        </div>
                                    </Form>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default LoginPage